import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { WalletDeposit } from '@root/features/wallet/deposit/ui/common/wallet-deposit'
import { PlatformUtil } from '@root/shared'
import { useTranslation } from '@root/shared/localization'
import { Share2Icon } from '@root/shared/ui-kit'

import { walletsManagerModelAtom } from '../../atoms'

import { WalletDetailsSection } from './wallet-details-section'

import type { WalletModel } from '@root/entities/wallet'

type Props = {
  wallet: WalletModel
}

export const WalletDetailsDeposit: React.FC<Props> = ({ wallet }) => {
  const { t } = useTranslation()
  const [model] = useAtom(walletsManagerModelAtom)
  const clearSelectedWallet = useAction(model.clearSelectedWallet)

  const handleShare = () => {
    PlatformUtil.share({
      text: wallet.address,
    })
  }

  return (
    <Root title={t('deposit')} onClose={clearSelectedWallet}>
      <Content>
        <WalletDeposit wallet={wallet} />
        <Button
          onClick={handleShare}
          size="h36"
          color="primary"
          radius="rounded"
          variant="solid"
          iconLeft={<Share2Icon />}
        >
          {t('common.share')}
        </Button>
      </Content>
    </Root>
  )
}

const Root = styled(WalletDetailsSection)`
  display: grid;
`

const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  align-items: justify;
  gap: 12px;
  padding-inline: 12px;
  padding-block: 10px;
`
